import { useCallback, useEffect, useRef, useState } from 'react';

import { DISPLAY_MODE, DisplayMode } from '~atoms';

export interface UseSelectorCollapseOptions {
  initialCollapsed: boolean | (() => boolean);
  forceCollapsed?: boolean;
  displayMode?: DisplayMode;
  onPopoverToggle?: () => void;
}

export interface UseSelectorCollapseResult {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  toggle: () => void;
}

const useSelectorCollapse = ({
  initialCollapsed,
  forceCollapsed,
  displayMode = DISPLAY_MODE.COLLAPSE,
  onPopoverToggle,
}: UseSelectorCollapseOptions): UseSelectorCollapseResult => {
  const [isCollapsed, setIsCollapsed] = useState(initialCollapsed);

  useEffect(() => {
    if (forceCollapsed === undefined || displayMode !== DISPLAY_MODE.POPOVER) return;
    setIsCollapsed(forceCollapsed);
  }, [forceCollapsed, displayMode]);

  const isCollapsedRef = useRef(isCollapsed);
  isCollapsedRef.current = isCollapsed;

  const toggle = useCallback(() => {
    if (isCollapsedRef.current && onPopoverToggle) onPopoverToggle();
    setIsCollapsed((prev) => !prev);
  }, [onPopoverToggle]);

  return { isCollapsed, setIsCollapsed, toggle };
};

export default useSelectorCollapse;
